export default __webpack_public_path__ + "d8d8de64e1386b2f91c38c6e58c9ac1e.png";